import { render, staticRenderFns } from "./PsClassifyMenu.vue?vue&type=template&id=16ef61c2&scoped=true&"
import script from "./PsClassifyMenu.vue?vue&type=script&lang=js&"
export * from "./PsClassifyMenu.vue?vue&type=script&lang=js&"
import style0 from "./PsClassifyMenu.vue?vue&type=style&index=0&id=16ef61c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef61c2",
  null
  
)

export default component.exports